import { defineMessages } from 'react-intl'

export default defineMessages({
  cashoutRequestSucceed: {
    defaultMessage:
      'Cash out requested! We will reach you within the next 5 working days',
  },
})
